import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.667 1.333H3.333a2 2 0 0 0-2 2V10a2 2 0 0 0 2 2h7.727l2.467 2.473a.669.669 0 0 0 1.14-.473V3.333a2 2 0 0 0-2-2m.666 11.06-1.526-1.533a.67.67 0 0 0-.474-.193h-8A.667.667 0 0 1 2.667 10V3.333a.667.667 0 0 1 .666-.666h9.334a.667.667 0 0 1 .666.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })